<!-- components/Sidebar/SidebarItem.vue -->
<template>
  <div
    class="sidebar-item"
    :class="{
      'sidebar-item--active': active,
      'sidebar-item--collapsed': collapsed
    }"
    @click="$emit('click')"
  >
    <div class="sidebar-item__icon">
       <el-icon>
  <component :is="item.icon" v-if="item.icon" class="sidebar-icon" />
      </el-icon>
    </div>
    
    <div 
      class="sidebar-item__content"
      :style="collapsed ? 'opacity: 0; width: 0;' : ''"
    >
      <span class="sidebar-item__label">{{ item.label }}</span>
    </div>

    <!-- 折叠状态下的提示工具 -->
    <div 
      v-if="collapsed" 
      class="sidebar-item__tooltip"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
import {
  
  User as UserIcon,
  ShoppingCart,
  Box,
  DataAnalysis,
  
} from '@element-plus/icons-vue'
export default {
  name: 'SidebarItem',
  components: {
    
    UserIcon,
    ShoppingCart,
    Box,
    DataAnalysis,
   
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    getIconComponent(iconName) {
      // 根据图标名称返回对应的组件
      const iconMap = {
        
        'User': UserIcon,
        'ShoppingCart': ShoppingCart,
        'Box': Box,
        'DataAnalysis': DataAnalysis,
        
      }
      return iconMap[iconName] || DataAnalysis
    }
  }
}
</script>

<style scoped>
.sidebar-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s;
  margin: 4px 10px;
  border-radius: 8px;
  overflow: auto;
}
.sidebar-icon {
  width: 1.2em;
  height: 1.2em;
  color: inherit;
}
.sidebar-item--active .sidebar-icon {
  color: #3498db;
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-item--active {
  background: rgba(52, 152, 219, 0.2);
  border-left: 3px solid #3498db;
}

.sidebar-item__icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdc3c7;
  /* flex-shrink: 0; */
  transition: color 0.2s;
}

.sidebar-item--active .sidebar-item__icon {
  color: #3498db;
}

.sidebar-item__content {
  display: flex;
  align-items: center;
  flex: 1;
  transition: all 0.3s;
  white-space: nowrap;
  margin-left: 12px;
}

.sidebar-item__label {
  font-size: 14px;
  font-weight: 500;
}

.sidebar-item__tooltip {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background: #2c3e50;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: auto;
  transition: all 0.3s;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.sidebar-item:hover .sidebar-item__tooltip {
  opacity: 1;
  visibility: visible;
  left: calc(100% + 10px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar-item__tooltip {
    display: none;
  }
}
</style>